import { NgModule } from '@angular/core';
import { UniversalTransferService } from './universal-transfer.service';
import { UniversalShortcutsService } from './universal-shortcuts.service';

@NgModule({})
export class DfUniversalModule {
    constructor(universalTransferService: UniversalTransferService, universalShortcutsService: UniversalShortcutsService) {}
}
